jQuery(function($){
	function elementLayout() {

	if( $('body').hasClass('is-article') ) {
		$('.navbar-fixed-bottom').toggleClass('navbar-fixed-bottom').toggleClass('navbar-fixed-top');
	}


	// var documentH = $(document).outerHeight();
	// var articles = $('.articles').outerHeight();
	// var logo = $('.logo').outerHeight();
	// var nav = $('.navbar-default').outerHeight();
	// console.log('logo', logo);
	// console.log('nav', nav);
	// console.log('articles', articles);
	// console.log('documentH', documentH);


		// tmp
		if( $( window ).width() > 768) {
			$('body').addClass('has-space-enough');		
		}

		( $('body').hasScrollBar() ) ? $('body').removeClass('has-no-scrollbar') : $('body').addClass('has-no-scrollbar');
	}

	elementLayout();
	$( window ).resize(function() {
		elementLayout();
	});

});